import * as React from 'react';
import * as header from './header.module.scss';

export const Header = ({ data, btnText }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  React.useEffect(() => {
    if (isOpen) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.removeAttribute('style');
    }
  }, [isOpen]);

  return (
    <header>
      <div className="container">
        <div className={header.topLogo}>
          <a href="/">
            <img
              src={"https://fs.advance.ru/landing-pages/icons/advance-logo/logo_2021.svg"}
              alt={"Advance Club"}
              className={header.topLogo__logo}
            />
          </a>
          <nav className={header.topLogo__navigation}>
            <button
              className={`${isOpen ? `${header.toggle} ${header.opened}` : `${header.toggle} ${header.closed}`}`}
              type="button"
              onClick={() => {setIsOpen(prevState => !prevState)}}
            >
              Открыть/закрыть меню
            </button>
            <div className={header.topLogo__linkWrapper} style={{left: isOpen ? '0' : '-100%'}}>
              {
                data.map((elem, index) => (
                  <a
                    className={header.topLogo__link}
                    href={elem.anchor}
                    data-target={elem.anchor}
                    onClick={() => {setIsOpen(false)}}
                    key={index}
                  >
                    {elem.linkTitle}
                  </a>
                ))
              }
            </div>
          </nav>
          <a className={header.topLogo__btn} href={"#widget"} data-target={"#widget"}>{btnText || "Зарегистрироваться"}</a>
        </div>
      </div>
    </header>
  );
};
